import { Navigate, useParams } from "react-router-dom";
import { RoutePath } from "../../../../../features/routes";

export const RoadmapShipmentPreparationDetail = () => {
  const { id } = useParams()

  const state = { from: RoutePath.SHIPMENT_PREPARATION }

  return <Navigate
    to={`../../${RoutePath.ROADMAPS}/${id}`}
    replace
    state={state}
  />
}
